/**
 * Created by h3 on 2017-11-16.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Elastic, Power3, Power4, TimelineLite, TweenLite} from "gsap";
import {TeslaTextStyles} from "../../../config/TeslaTextStyles";
import {Tesla} from "../../Tesla";
import {TeslaGameAssets} from "../../TeslaGameAssets";
import {TeslaGameConfig} from "../../TeslaGameConfig";
import {MathHelper} from "../../utils/MathHelper";

export class BonusSymbolFreespinView extends BaseView {

    private _layer:ScalableLayer;
    private _container:PIXI.Container;
    private _radialEffect:TimelineSprite;


    constructor(resourcesGroup:ResourcesGroupName) {
        super(resourcesGroup);
        this._layer = StageManager.getLayer(TeslaGameConfig.instance.LAYERS.SYMBOLS_FRAME_FOREGROUND.name);

    }

    protected initAnimations():void {
        this._container = new PIXI.Container();
        this._layer.addChild(this._container);

        this._radialEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.RADIAL_EFFECT));
        this._radialEffect.position.set(1177, 98);
        this._radialEffect.anchor.set(0.5, 0.5);
        this._radialEffect.scale.set(1.15, 1.15);
        this._radialEffect.blendMode = PIXI.BLEND_MODES.ADD;
        this._radialEffect.hide();
        this._layer.addChild(this._radialEffect);
    }

    public getLightningToCollectAnimation(bonusSymbolPoints:PIXI.Point, overlayWilds:boolean[][]):TimelineLite {


        let activeReel = this.getActiveReel(overlayWilds);

        const tl:TimelineLite = new TimelineLite();

        if(activeReel < 1) {
            return tl;
        }


        let activeReelPoints = new PIXI.Point();

        if(activeReel === 1) {
            activeReelPoints.set(496, 500);
        } else if(activeReel === 2) {
            activeReelPoints.set(637, 500);
        } else {
            activeReelPoints.set(771, 500);
        }

        const visualHeight = 308;


        let angle = MathHelper.angleBetweenPoints(activeReelPoints, bonusSymbolPoints);
        let distance = MathHelper.distanceBetweenPoints(activeReelPoints, bonusSymbolPoints);

        const lightningEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.PURPLE_LIGHTNING));
        lightningEffect.height = distance * (lightningEffect.height / visualHeight);
        lightningEffect.x = bonusSymbolPoints.x;
        lightningEffect.y = bonusSymbolPoints.y;
        lightningEffect.hide();
        lightningEffect.anchor.set(0.649, 0.07);
        lightningEffect.blendMode = PIXI.BLEND_MODES.ADD;
        lightningEffect.rotation = angle + (90 * PIXI.DEG_TO_RAD);
        this._container.addChild(lightningEffect);

        tl.add([
            () => Tesla.background.getBlinkAnimation(),
            Tesla.backgroundWindowAnimation.getWindowLightning(),
            lightningEffect.getAnimationAutoShowHide(true, true)
        ]);

        tl.add(() => this._container.removeChild(lightningEffect));

        return tl;
    }

    private getActiveReel(overlayWilds:boolean[][]):number {

        for(let reel:number = 0; reel < overlayWilds.length; reel++) {
            let collected = 0;
            for(let row:number = 0; row < overlayWilds[reel].length; row++) {
                if(overlayWilds[reel][row]) {
                    collected++;

                }
            }
            if(collected === 1 || collected === 2) {
                return reel;
            }
        }

        return 0;
    }

    public getLightningAnimation(bonusSymbolPoints:PIXI.Point):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const visualHeight = 308;

        const coilPoint = new PIXI.Point();
        coilPoint.set(1190, 105);

        let angle = MathHelper.angleBetweenPoints(bonusSymbolPoints, coilPoint);
        let distance = MathHelper.distanceBetweenPoints(bonusSymbolPoints, coilPoint);

        const lightningEffect = new TimelineSprite(GameResources.getTextures(TeslaGameAssets.PURPLE_LIGHTNING));
        lightningEffect.height = distance * (lightningEffect.height / visualHeight);
        lightningEffect.x = coilPoint.x;
        lightningEffect.y = coilPoint.y;
        lightningEffect.hide();
        lightningEffect.anchor.set(0.649, 0.07);
        lightningEffect.blendMode = PIXI.BLEND_MODES.ADD;
        lightningEffect.rotation = angle + (90 * PIXI.DEG_TO_RAD);
        this._container.addChild(lightningEffect);

        tl.add([
            () => Tesla.background.getBlinkAnimation(),
            Tesla.backgroundWindowAnimation.getWindowLightning(),
            lightningEffect.getAnimationAutoShowHide(true, true),
        ]);

        tl.add(() => this._container.removeChild(lightningEffect));

        return tl;
    }

    public getExtraFreespins(extraFs:number, bonusSymbolPoints:PIXI.Point):TimelineLite {

        let extraFsText = new PIXI.BitmapText(`+${extraFs}`, TeslaTextStyles.EXTRA_FS_TEXT_STYLE);
        extraFsText.alpha = 0;
        extraFsText.scale.set(0, 0);
        extraFsText.pivot.x = extraFsText.textWidth * 0.5;
        extraFsText.pivot.y = extraFsText.textHeight * 0.5;
        extraFsText.position.set(bonusSymbolPoints.x, bonusSymbolPoints.y);
        this._container.addChild(extraFsText);

        const tl:TimelineLite = new TimelineLite();


        tl.add([
            new TweenLite(extraFsText, 0.5, {alpha : 1, ease : Power4.easeOut}),
            new TweenLite(extraFsText.scale, 0.5, {x : 0.5, y : 0.5, ease : Elastic.easeOut.config(2.5, 1)}),
        ]);

        if(UserAgent.isMobile) {
            tl.add(this.getMobileExtraFsAnimation(extraFsText));
        } else {
            tl.add([
                new TweenLite(extraFsText.position, 0.5, {
                    x : this.getSpinButtonPositionX(),
                    y : this.getSpinButtonPositionY(),
                    ease : Power3.easeIn
                }),
                new TweenLite(extraFsText.scale, 0.5, {x : 0, y : 0, ease : Power3.easeIn}),
            ]);
        }


        tl.add(() => this._container.removeChild(extraFsText));

        return tl;
    }

    private getSpinButtonPositionX():number {
        return StageManager.orientation === Orientation.PORTRAIT ? 640 : 1150;
    }

    private getSpinButtonPositionY():number {
        return StageManager.orientation === Orientation.PORTRAIT ? 1000 : 490;
    }


    private getMobileExtraFsAnimation(extraFsText:PIXI.BitmapText):TimelineLite {

        const tl:TimelineLite = new TimelineLite();


        if(StageManager.orientation == Orientation.PORTRAIT) {
            tl.add([
                new TweenLite(extraFsText.position, 0.5, {
                    x : TeslaGameConfig.instance.GAME_WIDTH * 0.5,
                    y : TeslaGameConfig.instance.GAME_HEIGHT * 0.9,
                    ease : Power3.easeIn
                }),
                new TweenLite(extraFsText.scale, 0.5, {x : 0, y : 0, ease : Power3.easeIn}),
            ]);
        } else {

            if(GameSetting.isLeftHanded) {
                tl.add([
                    new TweenLite(extraFsText.position, 0.5, {
                        x : TeslaGameConfig.instance.GAME_WIDTH * 0.13,
                        y : TeslaGameConfig.instance.GAME_HEIGHT * 0.66,
                        ease : Power3.easeIn
                    }),
                    new TweenLite(extraFsText.scale, 0.5, {x : 0, y : 0, ease : Power3.easeIn}),
                ]);
            } else {
                tl.add([
                    new TweenLite(extraFsText.position, 0.5, {
                        x : TeslaGameConfig.instance.GAME_WIDTH * 0.87,
                        y : TeslaGameConfig.instance.GAME_HEIGHT * 0.66,
                        ease : Power3.easeIn
                    }),
                    new TweenLite(extraFsText.scale, 0.5, {x : 0, y : 0, ease : Power3.easeIn}),
                ]);
            }

        }

        return tl;

    }

}